import type { ClientConfig } from '@/types/client-config'
import { validateConfig } from './validate-config'

export async function loadConfig(): Promise<ClientConfig> {
  let response: Response
  try {
    response = await fetch('/config/config.json')
  } catch (err) {
    throw new Error(
      `Failed to fetch /config/config.json: ${err instanceof Error ? err.message : err}`,
    )
  }

  if (!response.ok) {
    throw new Error(`Failed to load /config/config.json: HTTP ${response.status}`)
  }

  const raw: unknown = await response.json()
  const result = validateConfig(raw)

  if (!result.ok) {
    throw new Error(result.error)
  }

  return result.config
}
